"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var PeoplesIcon = function PeoplesIcon(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? '20' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '20' : _ref$height;
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 19 19",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.88696 11.0637C5.13196 11.0637 1.63696 11.9412 1.63696 13.6887V15.0012H12.137V13.6887C12.137 11.9412 8.64196 11.0637 6.88696 11.0637ZM3.39196 13.5012C4.02196 13.0662 5.54446 12.5637 6.88696 12.5637C8.22946 12.5637 9.75196 13.0662 10.382 13.5012H3.39196ZM6.88696 9.75122C8.33446 9.75122 9.51196 8.57372 9.51196 7.12622C9.51196 5.67872 8.33446 4.50122 6.88696 4.50122C5.43946 4.50122 4.26196 5.67872 4.26196 7.12622C4.26196 8.57372 5.43946 9.75122 6.88696 9.75122ZM6.88696 6.00122C7.50946 6.00122 8.01196 6.50372 8.01196 7.12622C8.01196 7.74872 7.50946 8.25122 6.88696 8.25122C6.26446 8.25122 5.76196 7.74872 5.76196 7.12622C5.76196 6.50372 6.26446 6.00122 6.88696 6.00122ZM12.167 11.1087C13.037 11.7387 13.637 12.5787 13.637 13.6887V15.0012H16.637V13.6887C16.637 12.1737 14.012 11.3112 12.167 11.1087ZM11.387 9.75122C12.8345 9.75122 14.012 8.57372 14.012 7.12622C14.012 5.67872 12.8345 4.50122 11.387 4.50122C10.982 4.50122 10.607 4.59872 10.262 4.76372C10.7345 5.43122 11.012 6.24872 11.012 7.12622C11.012 8.00372 10.7345 8.82122 10.262 9.48872C10.607 9.65372 10.982 9.75122 11.387 9.75122Z",
    stroke: "none",
    fillRule: "nonzero",
    fill: "#75767A",
    fillOpacity: 1
  }));
};
PeoplesIcon.propTypes = {
  width: _propTypes.default.string,
  height: _propTypes.default.string
};
PeoplesIcon.defaultProps = {
  width: 24,
  height: 24
};
var _default = PeoplesIcon;
exports.default = _default;